import React from 'react';
import { motion } from 'framer-motion';
import './AreaCard.css';

const AreaCard = ({ area, onSelect }) => {
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
    hover: { 
      scale: 1.03, 
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      borderColor: area.color
    }
  };
  
  return (
    <motion.div 
      className="area-card"
      variants={cardVariants}
      whileHover="hover"
      onClick={onSelect}
    >
      <div className="area-icon" style={{ backgroundColor: `${area.color}20` }}>
        <span className="icon" style={{ color: area.color }}>
          {/* Aquí iría el icono correspondiente */}
          {getIconForArea(area.id)}
        </span>
      </div>
      
      <div className="area-content">
        <h3>{area.name}</h3>
        <p>{area.description}</p>
      </div>
      
      <div className="area-arrow">
        <span className="arrow-icon" style={{ color: area.color }}>→</span>
      </div>
    </motion.div>
  );
};

// Función auxiliar para obtener el icono correspondiente a cada área
// En una implementación real se utilizaría una librería de iconos como FontAwesome o React-Icons
const getIconForArea = (areaId) => {
  const icons = {
    'TRISTEZA': '♥',
    'ANSIEDAD': '⚠',
    'ESTRES': '⚡',
    'RUPTURA_PAREJA': '💔',
    'AUTOESTIMA': '★',
    'INSOMNIO': '☾'
  };
  
  return icons[areaId] || '•';
};

export default AreaCard;
